const entrypoint = process.env.REACT_APP_API_PLATFORM_ENDPOINT;

const sendEmailTemplated = async (data) => {
  const request = new Request(
    `${entrypoint}/communications/send-email-templated`,
    {
      body: JSON.stringify(data),
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }),
      method: "POST",
    }
  );

  return await fetch(request)
    .then((response) => response.json())
    .then((responseJSON) => {
      if (responseJSON.Error !== undefined) {
        throw Error(responseJSON.Error);
      }

      return responseJSON;
    });
};

const sendSmsTemplated = async (formData) => {
  const request = new Request(
    `${entrypoint}/communications/send-sms-templated`,
    {
      body: JSON.stringify(formData),
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }),
      method: "POST",
    }
  );

  return await fetch(request)
    .then((response) => response.json())
    .then((responseJSON) => {
      if (responseJSON.Error !== undefined) {
        throw Error(responseJSON.Error);
      }

      return responseJSON;
    });
};

export { sendEmailTemplated, sendSmsTemplated };
